var map = {
	"./fa-b2b-img1.png": 1487,
	"./fa-b2b-img2.png": 1488,
	"./fa-b2b-img3.png": 1489,
	"./fa-b2b-img4.png": 1490,
	"./fa-b2b-img5.png": 1491,
	"./fa-b2b-img6.png": 1492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2346;